namespace SPA
{
	export namespace BRW
	{
		export class New
			extends ui.tab.TabHTMLPresentation
		{

			private mForm: 											ui.Form.Form;
			private mObjectData: 								ui.Box.Box;
			private mResultData: 								ui.Box.Box;
			private theObject:									any;
			private withCustomerObject:					boolean;

			private List:												any;
			private listData:										any;
			private ResultText:									JQuery;
			private ResultAddress:							any;
			private AddressChanged:							boolean;

			private street:											ui.Form.TextInput;
			private housenumber:								ui.Form.TextInput;
			private postalcode:									ui.Form.TextInput;
			private city:												ui.Form.TextInput;
			private tempHide:										ui.Form.TextInput;

			public constructor( customerObject?: Wollmilch.Object.CustomerObject )
			{
				super();

				this.Initialize( {} );

				this.mObjectData										= new ui.Box.Box();
				this.mResultData										= new ui.Box.Box();
				this.theObject 											= customerObject ? customerObject : null;
				this.ResultText											= ui.$$.text( app.getMessage( 'BRW.GENERAL.message' ) );
				this.withCustomerObject							= customerObject ? true : false;
				this.ResultAddress									= null;
				this.List														= null;
				this.listData												= null;
				this.AddressChanged									= true;

				this.street													= new ui.Form.TextInput( '', '' );
				this.housenumber										= new ui.Form.TextInput( '', '' );
				this.postalcode											= new ui.Form.TextInput( '', '' );
				this.city														= new ui.Form.TextInput( '', '' );
				this.tempHide												= new ui.Form.TextInput( '', '' );

				this.constructInputFields();

				this.mForm = new ui.Form.Form(
				{
					action: 'MP01/requestAddress',
					classes: [ 'form-horizontal' ],
					invalid: ( inputs: Array<ui.Form.BasicInputField<HTMLElement>> ) =>
					{
						app.addNotify(
						{
							body: [ ui.text( app.getMessage( 'BRW.GENERAL.ERROR.body' ) ) ],
							context: 'danger',
							timeout: Number(app.getConfigValue("ToastTimeout")),
							title: [ ui.h( 4, app.getMessage( 'BRW.GENERAL.ERROR.title' ) ) ],
						});

						this.ResultText = ui.$$.text( app.getMessage('BRW.GENERAL.fillAllFields') );
					},
					method: 'POST',
					notSwitchable: true,
					submit: ( methode: ui.Form.FormMethod, action: string, parameter: ui.Form.IFormParameter ) =>
					{
						new Wollmilch.AJAX(
						{
							data: parameter,
							method: methode,
							on:
							{
								beforeSend: ( options: Wollmilch.IAJAXOptions ) =>
								{
									this.ResultText = ui.$$.text( app.getMessage( 'BRW.GENERAL.pleaseWait' ) );
									this.street.value( parameter.Address.street );
									this.housenumber.value( parameter.Address.housenumber );
									this.postalcode.value( parameter.Address.postalcode );
								},
								success: ( text: string ): void =>
								{
									let obj = null;
									try
									{
										obj = Wollmilch.jsonize( text );
									}
									catch ( e )
									{
										app.addNotify(
										{
											body: [ ui.text( app.getMessage( 'BRW.GENERAL.ERROR.body' ) ) ],
											context: 'danger',
											timeout: Number(app.getConfigValue("ToastTimeout")),
											title: [ ui.h( 4, app.getMessage( 'BRW.GENERAL.ERROR.title' ) ) ],
										});
										return;
									}

									if ( obj && !obj.success )
									{
										app.addNotify(
										{
											body: [ ui.text( app.getMessage( 'BRW.GENERAL.ERROR.body' ) ) ],
											context: 'danger',
											timeout: Number(app.getConfigValue("ToastTimeout")),
											title: [ ui.h( 4, app.getMessage( 'BRW.GENERAL.ERROR.title' ) ) ],
										});
										return;
									}

									if ( obj != null )
									{
										this.ResultAddress = obj;

										if ( 	obj.data && obj.data.List && obj.data.Status &&
											obj.data.List.Data == null && obj.data.List.KindOf == null && obj.data.Status.Summary === 0 )
										{
											app.addNotify(
											{
												body: [ ui.text( app.getMessage( 'BRW.GENERAL.ERROR.no_address' ) ) ],
												context: 'danger',
												timeout: 8500,
												title: [ ui.h( 4, app.getMessage( 'BRW.GENERAL.ERROR.title' ) ) ],
											});
											this.ResultText = ui.$$.text( app.getMessage( 'BRW.GENERAL.ERROR.no_address' ) );
											this.build();
											return;
										}

										if ( 	obj.data && obj.data.List &&
													obj.data.List.Data == null && obj.data.List.KindOf == null && obj.data.Adresse.RecordID == null )
										{
											app.addNotify(
											{
												body: [ ui.text( app.getMessage( 'BRW.GENERAL.addressNotFull' ) ) ],
												context: 'danger',
												timeout: Number(app.getConfigValue("ToastTimeout")),
												title: [ ui.h( 4, app.getMessage( 'BRW.GENERAL.ERROR.title' ) ) ],
											});
											return;
										}

										if ( obj.data && obj.data.List && obj.data.List.Data )
										{
											this.listData = [];

											let element = null;

											for ( let i = 0; i < obj.data.List.Data.length - 1 ; ++i )
											{
												element = obj.data.List.Data[i].trim();
												if ( element.length > 0 )
												{
													this.listData[element] = element;
												}
											}

											if ( obj.data.Adresse.Strasse ) { this.street.value( obj.data.Adresse.Strasse ); }
											if ( obj.data.Adresse.Hausnummer) { this.housenumber.value( obj.data.Adresse.Hausnummer ); }
											if ( obj.data.Adresse.Stadt ) { this.city.value( obj.data.Adresse.Stadt ); }

											let korrigierteAdr = obj.data.Adresse.PLZ;
											korrigierteAdr = korrigierteAdr
												.replace('*', "0").replace('*', "0").replace('*', "0").replace('*', "0").replace('*', "0");

											if ( obj.data.Adresse.PLZ ) { this.postalcode.value( korrigierteAdr ); }

											this.buildAddressInputForm();

											if ( obj.data.List.KindOf === 'street' )
											{
												this.AddressChanged = true;

												app.addNotify(
												{
													body: [ ui.text( app.getMessage( 'BRW.GENERAL.WARNING.noStreet' ) ) ],
													context: 'danger',
													timeout: Number(app.getConfigValue("ToastTimeout")),
													title: [ ui.h( 4, app.getMessage( 'BRW.GENERAL.WARNING.title' ) ) ],
												});

												this.street.css( 'display', 'hide' );
												this.tempHide = this.street;
												this.List = new ui.Form.Select(
												{
													name: 'Address.street',
													on:
													{
														change: () =>
														{
															this.street.css( 'display', 'block' );
															this.street = this.tempHide;
															btnSubmit.submit();
														},
													},
													option: this.listData,
												},
												);
												this.street = this.List;
												this.buildAddressInputForm();
											}

											if ( obj.data.List.KindOf === 'housenumber' )
											{
												this.AddressChanged = true;

												app.addNotify(
												{
													body: [ ui.text( app.getMessage( 'BRW.GENERAL.WARNING.noHousenumber' ) ) ],
													context: 'danger',
													timeout: Number(app.getConfigValue("ToastTimeout")),
													title: [ ui.h( 4, app.getMessage( 'BRW.GENERAL.WARNING.title' ) ) ],
												});

												this.housenumber.css( 'display', 'hide' );
												this.tempHide = this.housenumber;
												this.List = new ui.Form.Select(
												{
													name: 'Address.housenumber',
													on:
													{
														change: () =>
														{
															this.housenumber.css( 'display', 'block' );
															this.housenumber = this.tempHide;
															btnSubmit.submit();
														},
													},
													option: this.listData,
												},
												);
												this.housenumber = this.List;
												this.buildAddressInputForm();
											}

											if ( obj.data.List.KindOf === 'postalcode' )
											{
												this.AddressChanged = true;

												app.addNotify(
													{
														body: [ ui.text( app.getMessage( 'BRW.GENERAL.WARNING.noPostalcode' ) ) ],
														context: 'danger',
														timeout: Number(app.getConfigValue("ToastTimeout")),
														title: [ ui.h( 4, app.getMessage( 'BRW.GENERAL.WARNING.title' ) ) ],
													});

												this.postalcode.css( 'display', 'hide' );
												this.tempHide = this.postalcode;
												this.List = new ui.Form.Select(
												{
													name: 'Address.postalcode',
													on:
													{
														change: () =>
														{
															this.postalcode.css( 'display', 'block' );
															this.postalcode = this.tempHide;
															btnSubmit.submit();
														},
													},
													option: this.listData,
												},
												);
												this.postalcode = this.List;
												this.buildAddressInputForm();
											}

											if ( obj.data.List.KindOf === 'recordID' )
											{
												const index = ( Object.keys( obj.data.List.Data ) );

												for ( let i = 0; i < index.length - 0 ; ++i )
												{
													const idx = index[i];
													this.listData[idx] = obj.data.List.Data[idx];
												}

												this.List = new ui.Form.Select(
												{
													name: 'Address.' + obj.data.List.KindOf,
													on:
													{
														change: () =>
														{
															btnSubmit.submit();
														},
													},
													option: this.listData,
												},
												);
											}

										}

										if ( obj.data.RecordID )
										{
											this.buildResultData( obj.data );
										}

										this.build();
									}
								},
							},
							url: action,
						},
						Wollmilch.AJAXCallbase_e.BRW,
						).send();
					},
				},
				)
				.append(
					ui.$$.div().addClass( 'row' )
						.append( ui.$$.div().addClass( 'col-sm-12 col-md-6' )
							.append( this.mObjectData.Root() ),
						)
						.append( ui.$$.div().addClass( 'col-sm-12 col-md-6' )
							.append( this.mResultData.Root() ),
						),
				) as ui.Form.Form;

				this.mObjectData.addTitle( app.getMessage( 'BRW.GENERAL.LABEL.object' ) );
				this.mResultData.addTitle( app.getMessage( 'BRW.GENERAL.LABEL.result' ) );

				this.append( this.mForm );

				this.mForm.Initialize();

				const btnSubmit = $( this.mForm.Buttons.submit.getElement() ).text( app.getMessage( 'BRW.GENERAL.send' ) );
				const btnCancel = $( this.mForm.Buttons.cancel.getElement() ).text( app.getMessage( 'Aux.ABORT_BTN' ) );

				let showBtn: string = 'display: none';
				let showBox: string = 'display: none';
				if ( !this.withCustomerObject )
				{
					showBtn = 'display: inline';
					showBox = 'display: block';
				}

				new ui.Box.Box().append(
					ui.$$.div().append(
						ui.$$.div().append(
							ui.$$.div()
								.append( btnSubmit.attr( 'style', showBtn ) )
								.append( btnCancel.attr( 'style', showBtn ) )
							.addClass( 'col-xs-12' ),
						).addClass( 'row' ),
					).addClass( 'container-fluid' ),
				).attr('style', showBox ).appendTo( ui.$$.div().addClass( 'row' )
					.appendTo( this.mForm.Root() ),
				);

				this.rebuild(this.Root());

				if ( this.withCustomerObject )
				{
					btnSubmit.submit();
				}
			}

			public rebuild( root: JQuery|ui.base.BaseHTMLElement ): New
			{
				super.rebuild( root );

				this.build();

				return this;
			}

			private constructInputFields()
			{
				this.street = new ui.Form.TextInput
				('',
					{
						name: 'Address.street',
						placeholder: app.getMessage( 'BRW.GENERAL.street' ),
						readonly: this.withCustomerObject,
						required: true,
					},
				);
				this.housenumber = new ui.Form.TextInput
				('',
					{
						name: 'Address.housenumber',
						placeholder: app.getMessage( 'BRW.GENERAL.housenumber' ),
						readonly: this.withCustomerObject,
						required: true,
					},
				);
				this.postalcode = new ui.Form.TextInput
				( '',
					{
						name: 'Address.postalcode',
						placeholder: app.getMessage( 'BRW.GENERAL.postalcode' ),
						readonly: this.withCustomerObject,
						required: true,
					},
				);
				this.city = new ui.Form.TextInput
				( '',
					{
						name: 'Address.city',
						placeholder: app.getMessage( 'BRW.GENERAL.city' ),
						readonly: this.withCustomerObject,
						required: true,
					},
				);
			}

			private buildAddressInputForm(): void
			{
				const addObjDataInput = ( input: ui.Form.BasicInputField, baseclass: string[] ) =>
				{
					this.mForm.Input( input ); input.Base().addClass( baseclass.join( ' ' ) );
				};

				addObjDataInput( new ui.Form.HiddenTextInput( '', 'Address.recordID' ), [] );
				const parent = this.theObject ? this.theObject.ObjectNumber : null;
				addObjDataInput( new ui.Form.HiddenTextInput( parent, 'Parent' ), [] );

				if ( this.theObject )
				{
					const adr = this.theObject.ToObject().Object.Address;

					if ( !this.street.val() )
					{
						this.street.value( this.theObject.ToObject().Object.Address.Street );
					}

					if ( !this.housenumber.val() )
					{
						this.housenumber.value( this.theObject.ToObject().Object.Address.HouseNumber );
					}

					if ( !this.city.val() )
					{
						this.city.value( this.theObject.ToObject().Object.Address.City );
					}

					if ( !this.postalcode.val() )
					{
						this.postalcode.value( this.theObject.ToObject().Object.Address.PostalCode );
					}
				}

				let fg = ui.$$.div()
				.addClass( 'form-group clearfix' )
					.append( ui.$$.label().text( app.getMessage( 'Address.LABEL.COMB.Str_HNo' )  + '*' )
						.addClass( 'control-label col-xs-12 col-md-2' ) )
					.appendTo( this.mObjectData.Root() );
				addObjDataInput( this.street.rebuild( fg ),
					[ 'col-xs-12', 'col-md-7' ],
				);

				addObjDataInput( this.housenumber.rebuild( fg ),
					[ 'col-xs-12', 'col-md-3' ],
				);

				fg = ui.$$.div()
				.addClass( 'form-group clearfix' )
					.append( ui.$$.label().text( app.getMessage( 'Address.LABEL.COMB.PC_City' )  + '*' )
						.addClass( 'control-label col-xs-12 col-md-2' ) )
					.appendTo( this.mObjectData.Root() );
				addObjDataInput( this.postalcode.rebuild( fg ),
					[ 'col-xs-12', 'col-md-3' ],
				);

				addObjDataInput( this.city.rebuild( fg ),
					[ 'col-xs-12', 'col-md-7' ],
				);

				if ( this.List )
				{
					addObjDataInput(
						this.List
						.rebuild( ui.$$.div().addClass( 'form-group clearfix' )
						.append( ui.$$.label().text( app.getMessage('BRW.GENERAL.list') ).addClass( 'control-label col-xs-12 col-md-2' ) )
							.appendTo( this.mResultData.Root() ) ),
						[ 'col-xs-12', 'col-md-10' ],
					);
					this.ResultText = ui.$$.text( app.getMessage('BRW.GENERAL.pleaseSelect') );
					this.List = null;
				}
			}

			private buildResultForm(): void
			{
				const addObjDataInput = ( input: ui.Form.BasicInputField, baseclass: string[] ) =>
				{
					this.mForm.Input( input ); input.Base().addClass( baseclass.join( ' ' ) );
				};

				this.mResultData.append( this.ResultText );
			}

			private build(): void
			{
				this.mObjectData.empty();
				this.mObjectData.rebuild().append( ui.$$.br() );

				this.mResultData.empty();
				this.mResultData.rebuild().append( ui.$$.br() );

				this.mForm.clear();
				this.buildAddressInputForm();
				this.buildResultForm();
			}

			private buildResultData( data: any ): void
			{
				const objectNumber = data.ObjectNumber;
				app.addNotify(
				{
					body: [ ui.text( app.getMessage( 'BRW.GENERAL.SUCCESS.newobject' ) ) ],
					context: 'success',
					timeout: Number(app.getConfigValue("ToastTimeout")),
					title: [ ui.h( 4, app.getMessage( 'BRW.GENERAL.SUCCESS.title' ) ) ],
				});

				new Wollmilch.AJAX(
				{
					data: {},
					method: 'PUT',
					on:
					{
						success: ( text: string ): void =>
						{
							let obj: any = null;
							try
							{
								obj = Wollmilch.jsonize( text );
							}
							catch ( e )
							{
								app.addNotify(
								{
									body: [ ui.text( app.getMessage( 'BRW.GENERAL.ERROR.no_connect' ) ) ],
									context: 'danger',
									timeout: Number(app.getConfigValue("ToastTimeout")),
									title: [ ui.h( 4, app.getMessage( 'BRW.GENERAL.ERROR.title' ) ) ],
								});
								return;
							}

							if ( obj == null || obj.data == null )
							{
								if ( this.m_Entry) { app.getGlobalTabControl().removeTab(this.m_Entry); }

								app.getGlobalTabControl().addTab(
									app.getMessage( 'BRW.GENERAL.LABEL.tabName' ) + data.ObjectNumber,
									new SPA.BRW.Page( data ),
									true, true, false,
								);

								app.addNotify(
								{
									body: [ ui.text( app.getMessage( 'BRW.GENERAL.ERROR.no_data' ) ) ],
									context: 'danger',
									timeout: 7500,
									title: [ ui.h( 4, app.getMessage( 'BRW.GENERAL.ERROR.title' ) ) ],
								});

								return;
							}

							if ( !obj.success )
							{
								if ( obj.error )
								{
									const RESTError = new SPA.BRW.Exeption( obj.error.code );
									data.Exeption = { code: obj.error.code, message: '' };
								}
								else
								{
									app.addNotify(
									{
										body: [ ui.text( app.getMessage( 'BRW.GENERAL.ERROR.no_data' ) ) ],
										context: 'danger',
										timeout: 7500,
										title: [ ui.h( 4, app.getMessage( 'BRW.GENERAL.ERROR.title' ) ) ],
									});
								}

								if (this.m_Entry) { app.getGlobalTabControl().removeTab(this.m_Entry); }

								app.getGlobalTabControl().addTab(
									app.getMessage( 'BRW.GENERAL.LABEL.tabName' ) + data.ObjectNumber,
									new SPA.BRW.Page( data ),
									true, true, false,
								);
							}
							else
							{
								if ( this.m_Entry ) { app.getGlobalTabControl().removeTab(this.m_Entry); }

								app.getGlobalTabControl().addTab(
									app.getMessage( 'BRW.GENERAL.LABEL.tabName' ) + obj.data.ObjectNumber,
									new SPA.BRW.Page( obj.data ),
									true, true, false,
								);
							}
						},
					},
					url: 'MP01/calculate/' + encodeURIComponent( btoa( objectNumber ) ),
				},
				Wollmilch.AJAXCallbase_e.BRW,
				).send();

			}

		}

	}

}
